import React from 'react';
import { Box, Typography } from '@mui/material';
import { translate as t } from 'hooks/useTranslations';
import { OrganizationAccreditationConfig } from '../../../_types/accreditation';

interface ViewProps {
  config: OrganizationAccreditationConfig;
}

const View: React.FC<ViewProps> = ({ config }) => {
  return (
    <Box sx={{ gap: 6, display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <Typography
          variant='subtitleSm'
          sx={{ mb: 1 }}
        >
          {t('manageSolutions.accreditation.planExpiration')}
        </Typography>
        <Typography
          variant='bodySm'
          sx={{ pl: 3 }}
        >
          {config.expirationAt ? new Date(config.expirationAt).toLocaleDateString() : '--'}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <Typography
          variant='subtitleSm'
          sx={{ mb: 1 }}
        >
          {t('manageSolutions.accreditation.subscriptionType')}
        </Typography>
        <Typography
          variant='bodySm'
          sx={{ pl: 3 }}
        >
          {config.productLevel || '--'}
        </Typography>
      </Box>
    </Box>
  );
};

export default View;
